import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { RouterModule } from '@angular/router'

import { FlxIconModule, FlxMessageModule } from '@flowx/angular-ui-toolkit'
import { FlxNavMenuComponent } from '@flowx/designer/modules/layout/components/nav-menu/nav-menu.component'
import { PlatformStatusService } from '@flowx/designer/modules/platform-status/platform-status.service'
import { WorkspacesAndPermissionsStore } from '@flowx/designer/modules/workspaces/workspaces-and-permissions.store'

import { NavMenuStore } from '../nav-menu/nav-menu.store'

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  host: { class: 'w-full h-full' },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FlxMessageModule, FlxIconModule, RouterModule, FlxNavMenuComponent],
})
export class MainLayoutComponent {
  #workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)
  #navMenuStore = inject(NavMenuStore)

  isOrganizationArea = this.#workspacesAndPermissionsStore.isOrganizationArea

  permissions = this.#workspacesAndPermissionsStore.userAndWorkspacePermissions
  userAccessRights = this.#workspacesAndPermissionsStore.userAccessRights
  platformStatusService = inject(PlatformStatusService)

  someComponentsAreDown = computed(() => this.platformStatusService.downComponents().length > 0)
  firstDownComponent = computed(() => this.platformStatusService.downComponents()[0] ?? null)

  canReadPlatformStatus = computed(() => {
    const permissions = this.permissions()
    const isOrganizationArea = this.isOrganizationArea()

    return isOrganizationArea
      ? permissions['org_platform_status_read']
      : permissions['wks_platform_status_read']
  })

  navMenuItems = this.#navMenuStore.navMenuItems
}
